import { css, type Theme } from "@emotion/react";

/* DropdownMenu.Content renders in a portal, so a wrapper selector can't reach it;
   override its 224px min-width globally the same way CollectionDropdown does. */
export const dropdownMenuContent = (theme: Theme) => css`
  .DropdownMenuContent {
    min-width: max-content !important;
    padding-inline: ${theme.ds5.dropdown.paddingX.small};
  }
`;
